import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as UserActionCreators from '../../actions/user'

class UserNameContainer extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    userId: PropTypes.string,
    users: PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
  }

  static defaultProps = {
    user: null,
    userId: '',
  }

  static styles = () => ({
  })

  static mapStateToProps(state) {
    return {
      users: state.users,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      userActions: bindActionCreators(UserActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { userId, userActions } = this.props
    // If we already have a user, don't look it up
    if (!this.user()) {
      userActions.fetchUser(userId)
    }
  }

  user() {
    const { user, userId, users } = this.props
    return user || users[userId]
  }

  userName() {
    const user = this.user() || { name: this.props.userId }
    return `${user.name} (${user.email})`
  }

  render() {
    return this.userName()
  }
}

export default connect(
  UserNameContainer.mapStateToProps,
  UserNameContainer.mapDispatchToProps,
)(UserNameContainer)
